<template>
    <div class="forum-detail-wrapper">
        <Head :title="$tc('header.forumdetails')"/>
        <div class="forum-detail-inner" v-if="detailData">
            <Video :detail="detailData"/>
            <div class="forum-content">
                <div class="detail-info">
                    <h4 class="title" v-html="detailData.name"></h4>
                    <span class="time" v-if="detailData.startTime">{{dateRange(detailData.startTime, detailData.endTime)}}</span>
                    <p v-html="detailData.brief" :style="{ height: isOpen ? 'auto' : '4.26rem'  }">
                    </p>
                    <div @click="isOpen = !isOpen" :class="isOpen && 'isopen'" >
                        {{isOpen ? "收起" : "展开" }}
                        <img src="./../../assets/img/icon_down.png" alt="png">
                    </div>
                </div>
                <div class="share-info" v-if="false">
                    <span>分享至</span>
                    <img src="./../../assets/img/img_qq.png" alt="qq" />
                    <img src="./../../assets/img/img_wechat.png" alt="wechat" />
                    <img src="./../../assets/img/img_wb.png" alt="wb" />
                    <img src="./../../assets/img/img_pyq.png" alt="pyq" />
                </div>
                <div v-if="detailData.publicity"  class="host-info publicity" v-html="detailData.publicity"></div>
                <div class="host-info"
                    v-show="
                        detailData.agendas && detailData.agendas.length ||
                        detailData.guests && detailData.guests.length ||
                        detailData.firms && detailData.firms.length
                        "
                    >
                    <div class="host-nav">
                        <template v-for="(item, index) in navMenus">
                            <div
                                v-if="
                                    index == 0 && detailData.agendas && detailData.agendas.length ||
                                    index == 1 && detailData.guests && detailData.guests.length ||
                                    index == 2 && detailData.firms && detailData.firms.length
                                "
                                class="nav-item"
                                :class="{ active: currentIndex == index }"
                                :key="index"
                                @click="currentIndex = index"
                            >
                                {{item}}
                            </div>
                        </template>
                    </div>
                    <div v-show="currentIndex == 0" class="timeline-info">
                        <div class="timeline-border">
                            <div class="host-row" v-for="(item, index) in detailData.agendas" :key="index">
                                <div class="host-label">{{dateRange(item.startTime, item.endTime, true)}}</div>
                                <div class="host-desc">{{item.name}}</div>
                            </div>
                        </div>
                    </div>
                    <div v-show="currentIndex == 1" class="guest-info">
                        <div
                            class="guest-item"
                            v-for="(item, index) in detailData.guests"
                            :key="index"
                            @click="goSpeakerDetail(item)"
                        >
                            <img :src="item.imgUrl" :alt="item.name" class="guest-pic">
                            <div>
                                <div class="guest-name">{{item.name}}</div>
                                <div class="guest-desc">{{item.title}}</div>
                            </div>
                        </div>
                    </div>
                     <div v-show="currentIndex == 2" class="company-info">
                        <div
                            class="company-item"
                            v-for="(item, index) in detailData.firms"
                            :key="index"
                        >
                            <div @click="goCompanyDetail(item)">
                                <img :src="item.logo" :alt="item.name" class="company-pic">
                                <div class="company-name">{{item.name}}</div>
                                <div class="company-desc" :style="{height: item.linkUrl ? '17.6vw' : '28vw', marginBottom: item.linkUrl ? '4.8vw' : '0'}" v-html="item.brief"></div>
                            </div>
                            <div class="company-more" :style="{display: item.linkUrl ? 'block' : 'none'}" @click="goCompanyLink(item)">了解更多</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="id-foot">
            <div class="foot-row">
                <div>
                    四川省发展和改革委员会 <br/>
                    中共四川省委网络安全和信息化委员会办公室
                </div>
                <div>
                    <img src="./../../assets/img/weizhan.jpg" alt="wxgzh_pop" class="foot-code">
                    <div class="code-desc">微信公众号</div>
                </div>
            </div>
             <div class="foot-row">
                <div>
                   <div class="foot-desc"> 四川封面传媒有限责任公司</div>
                   <div>
                       联系电话：12341251 <br />
                       邮政编码：610000
                   </div>
                </div>
                <div>
                    <img src="./../../assets/img/phone_code.png" alt="phone_code" class="foot-code">
                    <div class="code-desc">微信公众号</div>
                </div>
            </div>
            <div class="foot-line">
                <div>川公网安备案号51010402000435号</div>
                <div>蜀ICP备15028104号-1</div>
                <div>网站标识码：666886</div>
            </div>
            <div class="foot-line">
               © CopyRight 2019, thecover.cn, Inc.All Rights Reserved
            </div>
        </div>
        <Empty :emptydata="emptydata" v-if="emptydata"/>
    </div>
</template>

<script>

import Video from '@/components/Video.vue'

import Filters from '@/utils/filters'
import { mapState, mapMutations } from 'vuex'

export default {
    name: 'ForumDetail',
    data () {
        return {
            id: '',
            detailData: null,
            currentIndex: 0,
            timeSize: '',
            emptydata: null,
            isOpen: false,
            navMenus: ['会议议程', '重要嘉宾', '路演企业']
        }
    },
    computed: {
        ...mapState(['lang'])
    },
    components: {
        Video
    },
    created () {
        this.id = this.$route.params.id
        this.getDetail()
    },
    mounted () {
        this.$Common.track('load', {
            name: '云论坛详情页',
            id: this.id,
            type: '云论坛'
        })
        clearTimeout(window.timeoutIds)
    },
    beforeRouteLeave (to, form, next) {
        this.$Common.track('unload', {
            name: '云论坛详情页',
            id: this.id,
            type: '云论坛'
        }).then(() => {
            next()
        })
    },
    methods: {
        ...mapMutations(['setShowLoading']),
        getDetail () {
            this.$Api.getForumDetail({
                forumId: this.id
            }).then((data) => {
                this.detailData = data.forum || null
                !this.detailData && (this.emptydata = {
                    type: 'nodata'
                })
                this.setShowLoading(false)
                data && data.share && this.share(data.share)
                // 设置当前tab
                if ((this.detailData.agendas && this.detailData.agendas.length)) {
                    this.currentIndex = 0
                } else if ((this.detailData.guests && this.detailData.guests.length)) {
                    this.currentIndex = 1
                } else if ((this.detailData.firms && this.detailData.firms.length)) {
                    this.currentIndex = 2
                }
            }).catch(() => {
                this.emptydata = {
                    type: 'nonetwork'
                }
                this.setShowLoading(false)
            })
        },
        goCompanyDetail (item) {
            // 去企业详情页
            this.$router.push({
                path: '/company',
                query: item
            })
        },
        goCompanyLink (item) {
            window.open(item.linkUrl, '_blank')
        },
        goSpeakerDetail (item) {
            // 去嘉宾详情页
            this.$router.push({
                path: '/speakers/' + item.id
            })
        },
        share (obj) {
            this.$nextTick(() => {
                this.$Common.onshare(obj)
            })
        },
        // 分享到新浪微博
        shareToSinaWB (event) {
            event.preventDefault()
            var _shareUrl =
                'http://v.t.sina.com.cn/share/share.php?appkey=3150526008'// 真实的appkey，必选参数
            _shareUrl += '&url=' + encodeURIComponent(this.shareInfo.shareUrl) // 参数url设置分享的内容链接|默认当前页location，可选参数
            _shareUrl += '&title=' + encodeURIComponent(this.shareInfo.shareTitle) // 参数title设置分享的标题|默认当前页标题，可选参数
            _shareUrl += '&source=' + encodeURIComponent('')
            _shareUrl += '&sourceUrl=' + encodeURIComponent('')
            _shareUrl += '&content=' + 'utf-8' // 参数content设置页面编码gb2312|utf-8，可选参数
            _shareUrl += '&pic=' + encodeURIComponent(this.shareInfo.shareImg) // 参数pic设置图片链接|默认为空，可选参数
            window.open(_shareUrl, '_blank')
        },
        // 分享到QQ空间
        shareToqq (event) {
            event.preventDefault()
            var _shareUrl =
                'https://connect.qq.com/widget/shareqq/iframe_index.html?'
            _shareUrl += 'url=' + encodeURIComponent(this.shareInfo.shareUrl) // 分享的链接
            _shareUrl += '&title=' + encodeURIComponent(this.shareInfo.shareTitle) // 分享的标题
            window.open(_shareUrl, '_blank')
        },
        changeCurIndex (index) {
            this.currentIndex = index
        },
        // 日期格式化
        dateRange (start, end, flag) {
            const datestr = this.lang === 'en' ? Filters.date.rangeMin(start, end, '/') : Filters.date.rangeMin(start, end, 'zh')
            return flag ? datestr.split(' ')[1] : datestr
        },
        filterContent (data) {
            return Filters.filterContent(data)
        }
    }
}
</script>

<style lang="scss">
    .forum-detail-wrapper {
        font-size: 0;
        background: #F3F3F3;
        * {
            box-sizing: border-box;
        }
        .forum-content {
            padding: 0 ;
            .empty-wrapper {
                height: auto;
            }
        }
        .detail-info {
            padding: 4.167vw 4.63vw;
            line-height: 1.4;
            background: #ffffff;
            margin-bottom: 2.133vw;
            h4 {
                font-size: 4.259vw;
                margin-bottom: 0.926vw;
                word-wrap: break-word;
                color: rgba(0, 0, 0, 0.85);

                overflow: hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-box-orient: vertical;
                -webkit-line-clamp: 2;
                word-wrap: break-word;
            }
            span {
                font-size: 3.148vw;
                display: block;
                color: rgba(0, 0, 0, 0.65);
            }
            p {
                font-size: 3.796vw;
                line-height: 1.42rem;
                overflow: hidden;
                margin-top: 2.778vw;
                word-wrap: break-word;
                color: rgba(0, 0, 0, 0.45);
            }
            div {
                font-size: 3.733vw;
                color: #5993F7;
                line-height: 5.333vw;
                margin-top: 1.333vw;
                display: inline-block;
                display: flex;
                align-items: center;
               img {
                   margin-left: 1.333vw;
                    width: 2.933vw;
                }
                &.isopen img {
                    transform: rotate(180deg);
                }
            }

        }
        .share-info {
            padding: 4vw;
            font-size: 3.467vw;
            color: rgba(0, 0, 0, 0.45);
            line-height: 4.8vw;
            display: flex;
            align-items: center;
            border-top: 0.267vw solid #DCDCDC;
            margin-bottom: 2.133vw;
            background: #ffffff;
            img {
                width: 6.667vw;
                height: 6.667vw;
                margin-left: 9.333vw;
                display: block;
            }
        }
        .host-info {
            background: #ffffff;
            margin-bottom: 2.133vw;
            font-size: 3.467vw;
            line-height: 4.8vw;
            color: rgba(0, 0, 0, 0.85);
            &.publicity {
                padding: 4vw;
                // p {
                //     margin-bottom: 2vw;
                // }
            }
            &:last-child {
                margin-bottom: 0;
            }
            .host-row {
                display: flex;
                align-items: center;
                border-bottom: 1px solid #DCDCDC;
            }
            .host-label {
                padding: 4vw;
                font-weight: 600;
                height: 100%;
            }
            .host-desc {
                font-size: 3.2vw;
                font-weight: 400;
                color: rgba(0, 0, 0, 0.65);
                line-height: 4.8vw;
                padding: 4vw;
                flex: 1;
                border-left: 1px solid #DCDCDC;
            }
        }
        .host-nav {
            display: flex;
            align-items: center;
            padding: 4vw;
            justify-content: space-around;
            .nav-item {
                line-height: 9.6vw;
                background: #EDF3FE;
                font-size: 4.267vw;
                font-weight: 600;
                color: rgba(0, 0, 0, 0.85);
                padding: 0 6.133vw;
                &.active {
                    color: #ffffff;
                    background: #2E76F3;
                }
            }
        }
        .timeline-info {
            .timeline-border{
                border-top: 1px solid #DCDCDC;
            }
            padding-bottom: 6.667vw;
        }
        .guest-info {
            padding: 4vw;
            background: #ffffff;
            display: flex;
            flex-wrap: wrap;
            justify-content: space-between;
            .guest-item {
                width: 44vw;
                padding: 2.667vw;
                display: flex;
                align-items: center;
                border: 1px solid #F3F3F3;
                margin-bottom: 2.667vw;
            }
            .guest-pic {
                width: 16vw;
                height: 24vw;
                margin-right: 2.667vw;
            }
            .guest-name {
                font-size: 3.733vw;
                font-weight: 600;
                color: rgba(0, 0, 0, 0.85);
                line-height: 5.333vw;
                margin-bottom: 0.8vw;
            }
            .guest-desc {
                width: 20.533vw;
                font-size: 2.933vw;
                color: rgba(0, 0, 0, 0.65);
                line-height: 4.267vw;
                text-align: justify;

                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-box-orient: vertical;
                -webkit-line-clamp: 4;
                word-break: break-all;
                overflow: hidden;
            }
        }
        .company-info {
            padding: 4vw;
            background: #ffffff;
            display: flex;
            flex-wrap: wrap;
            justify-content: space-between;
            .company-item {
                width: 44vw;
                background: #F6F7FA;
                padding: 4.267vw;
                margin-bottom: 2.667vw;
            }
            .company-pic {
                width: 14.133vw;
                height: 14.133vw;
                border-radius: 50%;
                display: block;
                margin: 0 auto 4.267vw;
            }
            .company-name {
                font-size: 3.2vw;
                font-weight: 600;
                color: rgba(0, 0, 0, 0.85);
                line-height: 4.267vw;
                margin-bottom: 1.333vw;
                text-align: center;
            }
            .company-desc {
                height: 17.6vw;
                overflow: auto;
                font-size: 2.667vw;
                color: rgba(0, 0, 0, 0.45);
                line-height: 3.733vw;
                margin-bottom: 4.8vw;
                text-align: justify;
            }
            .company-more {
                width: 14.4vw;
                line-height: 6.4vw;
                border-radius: 3.2vw;
                opacity: 0.69;
                border: 0.267vw solid #5993F7;
                font-size: 2.4vw;
                color: #5993F7;
                text-align: center;
                margin: 0 auto;
            }

        }
        .id-foot {
            background: #1B33A7;
            padding: 9.6vw 4vw 2.667vw;
            color: rgba(255,255,255,0.8);
            img {
                width: 16.533vw;
                height: 16.533vw;
                background: #ffffff;
            }
            .foot-row {
                font-size: 3.2vw;
                line-height: 6vw;
                letter-spacing: 0.267vw;
                display: flex;
                align-items: center;
                justify-content: space-between;
                margin-bottom: 5.333vw;
                &:last-child {
                    margin-bottom: 0;
                }
            }
            .code-desc {
                font-size: 1.867vw;
                line-height: 2.4vw;
                margin-top: 1vw;
                text-align: center;
            }
            .foot-desc {
                margin-bottom: 5.333vw;
            }
            .foot-line {
                font-size: 1.867vw;
                line-height: 2.4vw;
                display: flex;
                align-items: center;
                justify-content: center;
                div {
                    margin: 0 2.667vw  1.333vw;
                }
            }
        }
        .no-more {
            width: 100%;
            font-size: 2.933vw;
            text-align: center;
            padding-bottom: 4vw;
        }
    }
</style>
